// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"e50ea19f9df36850","1221":"2f8daefc5b589185","3602":"ae60ce2c82cc8aa0","4937":"793a42c69ab869d6"}[chunkId] + ".css";
};